import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../../context/AuthContext';
import { googleAuthWeb } from '../../services/api';
import { toast } from 'react-toastify';
import Navbar from '../../components/Navbar/Navbar';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css';

function Login() {
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth();
    const [error, setError] = useState(null);

    const handleGoogleSuccess = async (credentialResponse) => {
        setError(null);
        try {
            // credentialResponse.credential is the Google ID token
            const userData = await googleAuthWeb(credentialResponse.credential);
            login(userData);
            toast.success(`¡Bienvenido${userData.user?.username ? ', ' + userData.user.username : ''}!`, {
                position: 'bottom-center',
                autoClose: 3000,
            });
            navigate(location.state?.from || '/');
        } catch (err) {
            setError(err.message || 'Error al iniciar sesión con Google.');
        }
    };

    return (
        <div className='container'>
            <Navbar />
            <div className="login-container">
                <div className="login-box">
                    <div className="login-header">
                        <a href="/" className="home-icon">🏠</a>
                        <h2>Iniciar sesión</h2>
                    </div>

                    <p className="login-subtitle">
                        Usá tu cuenta de Google para acceder a Footy Games
                    </p>

                    <div className="google-btn-wrap">
                        <GoogleLogin
                            onSuccess={handleGoogleSuccess}
                            onError={() => setError('El inicio de sesión con Google fue cancelado o falló.')}
                            theme="outline"
                            size="large"
                            width="320"
                            text="continue_with"
                            locale="es"
                            shape="rectangular"
                        />
                    </div>

                    {error && <p className="error-text">{error}</p>}
                </div>
            </div>
        </div>
    );
}

export default Login;
